import {createRouter, createWebHashHistory} from "vue-router";

const Home = () => import("@pages/Home.vue");

// const Media = () => import("@pages/media/Media.vue");
const Character = () => import("@pages/seeroo/Character.vue");
const CharacterGrid = () => import("@pages/seeroo/CharacterGrid.vue");
const CharacterAnime = () => import("@pages/seeroo/CharacterAnime.vue");
const Age = () => import("@pages/seeroo/Age.vue");
const EpisodeLatest = () => import("@pages/media/EpisodeLatest.vue");

const History = () => import("@pages/media/History.vue");
const EpisodeLiked = () => import("@pages/media/EpisodeLiked.vue");
import DetailsModal from "./components/DetailsModal.vue";
import AgeMedia from "./pages/seeroo/AgeMedia";
import TheatreWatch from "./pages/theatre/TheatreWatch";
import Faq from "@components/Layout/Faq.vue";
import News from "@components/Layout/News.vue";
import NewsDetails from "@components/Layout/NewsDetails.vue";


const Watch = () => import("@pages/Watch.vue");

//Movie
const MovieStream = () => import("@pages/movie/MovieStream.vue");
const Search = () => import("@pages/Search.vue");

const Profile = () => import("@pages/profile/index.vue");
const ProfileForm = () => import("@pages/profile/profile-form.vue");
const ChangePassword = () => import("@pages/profile/change-password.vue");
const MyFund = () => import("@pages/profile/my-fund.vue");
const ExtendRights = () => import("@pages/profile/extend-rights.vue");
const ViewedHistory = () => import("@pages/profile/viewed-history.vue");

const Payment = () => import("@pages/payment/index.vue");
const Qpay = () => import("@pages/payment/qpay.vue");
const Transfer = () => import("@pages/payment/transfer.vue");
const Card = () => import("@pages/payment/card.vue");
const Content = () => import("@pages/Content.vue");

const Actor = () => import("@pages/Actor");
const Stream = () => import("@pages/media/Stream.vue");
const Policy = () => import("@pages/Policy");

//Theatre
const Theatre = () => import("@pages/theatre/Theatre.vue");
const MediaGrid = () => import("@pages/theatre/SeerooMedia.vue");
const TheatreMedia = () => import("@pages/theatre/TheatreMedia.vue");
const TheatreDetail = () => import("@pages/theatre/TheatreDetail.vue");

const routes = [
    {
        path: "/",
        component: Home,
    },
    {
        path: "/series",
        component: Theatre,
        children: [
            {
                path: '',
                redirect: () => {
                    return '/series/all/all/all/new?t=Бүх%20ангилал';
                }
            },
            {
                path: ":cat/:season/:status/:sort",
                component: MediaGrid,
            },
        ]
    },
    {
        path: "/character",
        component: Character,
        redirect: () => {
            return '/character/all'
        },
        children: [
            {
                path: ":character",
                component: CharacterGrid,
            },
        ]
    },
    {
        path: "/character/anime/list/:id",
        component: CharacterAnime
    },
    {
        path: "/age",
        component: Age,
        redirect: () => {
            return '/age/all'
        },
        children: [
            {
                path: ":age",
                component: AgeMedia,
            },
        ]
    },
    {
        path: "/series/detail/:id",
        component: DetailsModal
    },
    {
        path: "/episode/new",
        component: EpisodeLatest
    },
    {
        path: "/episode/liked",
        component: EpisodeLiked
    },

    {
        path: "/movie/stream/:id",
        component: MovieStream,
    },

    {
        path: "/payment",
        component: Payment,
    },
    {
        path: "/payment/qpay",
        component: Qpay,
    },
    {
        path: "/payment/transfer",
        component: Transfer,
    },
    {
        path: "/payment/card",
        component: Card,
    },
    {
        path: "/search",
        component: Search,
    },
    {
        path: "/content/:id",
        component: Content,
    },
    {
        path: "/watch/:media/",
        component: Stream,
        children: [
            {
                path: ":episode",
                component: Watch,
            },
        ]
    },

    {
        path: "/profile",
        component: Profile,
        children: [
            {
                path: "/profile/",
                component: ProfileForm,
            },
            {
                path: "/profile/change-password",
                component: ChangePassword,
            },
            {
                path: "/profile/my-fund",
                component: MyFund,
            },
            {
                path: "/profile/extend-rights",
                component: ExtendRights,
            },
            {
                path: "/profile/viewed-history",
                component: ViewedHistory,
            },
        ]
    },

    {
        path: "/actor/:id",
        component: Actor,
    },
    {
        path: "/policy",
        component: Policy,
        props: {
            isHeader: false,
            isSidebar: false,
            isFooter: false
        },
    },

    {
        path: "/theatre",
        component: Theatre,
        name: "Theatre",
        children: [
            {
                path: '/theatre',
                redirect: '/theatre/all/all'
            },
            {
                path: ":cat/:sort",
                component: TheatreMedia,
            },
        ]
    },
    {
        path: "/theatre/detail/:id",
        component: TheatreDetail,
    },

    {
        path: "/theatre/watch/:id",
        component: TheatreWatch,
    },
    {
        path: "/faq",
        component: Faq,
    },

    {
        path: "/history",
        component: History,
    },

    {
        path: "/news",
        component: News,
    },
    {
        path: "/news/detail/:id",
        component: NewsDetails,
    },

    {path: "/:pathMatch(.*)*", redirect: "/"},
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    linkActiveClass: 'active',
    scrollBehavior(to, __, savedPosition) {
        if (to.query.media == undefined) {
            if (to.query.scrollTop) {
                return {left: 0, top: to.query.scrollTop};
            }

            if (savedPosition) {
                return savedPosition;
            }

            return {left: 0, top: 0};
        }
    },
});

export default router;
